import React from 'react';
import { ButtonLink } from '../ui/ButtonLink';
import { useLanguage } from '../../contexts/LanguageContext';
export function FinalCta() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="cta-title" className="px-3 pb-6 lg:px-5" data-id="element-338" data-mp="br5osnvk2lr6">
      <div className="mx-auto flex min-h-[60vh] max-w-6xl flex-col items-center justify-center rounded-lg bg-ink px-6 py-20 text-center text-bg lg:rounded-xl" data-id="element-339" data-mp="bpbbnvqizxxn">
        <h2 id="cta-title" className="max-w-[15ch] text-[40px] font-bold leading-[1.02] tracking-[-0.02em] lg:text-[80px]" data-id="element-340" data-mp="3g6owzjemguq7">
          {t('cta.title')}
        </h2>
        <p className="mt-5 max-w-[42ch] text-[18px] leading-relaxed opacity-80" data-id="element-341" data-mp="3oxpaofybc02x">{t('cta.body')}</p>
        <div className="mt-10 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row" data-id="element-342" data-mp="3k7haiouj1lsa">
          <ButtonLink to="/onboarding/performer" variant="accent" size="lg" data-id="element-343" data-mp="2whel6ghzytxd">
            {t('cta.perform')}
          </ButtonLink>
          <ButtonLink to="/onboarding/organiser" variant="outline" size="lg" className="border-bg/30 bg-transparent text-bg hover:border-bg/60" data-id="element-344" data-mp="2sf033ym5jy75">
            {t('cta.organise')}
          </ButtonLink>
        </div>
      </div>
    </section>;
}